var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,13H8l.71-.29,1-1L10,11V9l-.29-.71-1-1L8,7H6l-.71.29-1,1L4,9v2l.29.71,1,1ZM6,9.41,6.41,9H7.59L8,9.41v1.18L7.59,11H6.41L6,10.59ZM23.71,4.29l-1-1L22,3H10V2l-.29-.71-1-1L8,0H2L1.29.29l-1,1L0,2V20l.29.71,1,1L2,22H22l.71-.29,1-1L24,20V5ZM2,19.59V2.41L2.41,2H7.59L8,2.41V5H21.59l.41.41v9.18L17.41,10l-1-1h-.82l-1,1-10,10H2.41Zm20,0-.41.41H7.41L16,11.41l6,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageFolder);
export default __webpack_public_path__ + "static/1765983986/media/icon-image-folder.df6705b02b31e43a4b3f441b66d8b707.svg";
export { ForwardRef as ReactComponent };